<template>
    <div data-tabs-body class="page-object-tabs__content">
        <div v-if="!!similarPropertiesByArea && similarPropertiesByArea.length > 0" class="page-object-tabs__body">
            <div class="cards-main">
                <property-slider
                    :properties="similarPropertiesByArea"
                ></property-slider>
                <go-to-properties-button></go-to-properties-button>
            </div>
        </div>
        <div v-if="!!otherPropertiesByDistrict && otherPropertiesByDistrict.length > 0" class="page-object-tabs__body">
            <div class="cards-main">
                <property-slider
                    :properties="otherPropertiesByDistrict"
                ></property-slider>
                <go-to-properties-button></go-to-properties-button>
            </div>
        </div>
        <div v-if="!!similarPropertiesByPrice && similarPropertiesByPrice.length > 0" class="page-object-tabs__body">
            <div class="cards-main">
                <property-slider
                    :properties="similarPropertiesByPrice"
                ></property-slider>
                <go-to-properties-button></go-to-properties-button>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper, {EffectFade, Navigation, Pagination} from 'swiper';
import LoaderGray from "../loaders/LoaderGray.vue";

export default {
    name: "SimilarPropertiesSlidersWrapper",
    components: {LoaderGray},
    props: {
        similarPropertiesByArea: {
            type: Array,
            default: () => []
        },
        otherPropertiesByDistrict: {
            type: Array,
            default: () => []
        },
        similarPropertiesByPrice: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            swiper: null,
            nextPage: 2,
            isLoading: false
        }
    },
    methods: {
        initSwiperCards() {
            this.isLoading = true;
            let cardMainSliders = document.querySelectorAll(".cards-main__slider");
            cardMainSliders.forEach((slider, index) => {
                if (slider.__swiper__) {
                    slider.__swiper__.destroy(true, true);
                }

                let swiper = new Swiper(slider, {
                    modules: [Pagination, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        }
                    },
                    navigation: {
                        prevEl: slider.querySelector('.cards-main-button_prev'),
                        nextEl: slider.querySelector('.cards-main-button_next')
                    }
                });
                slider.__swiper__ = swiper;
            });

            this.isLoading = false;
        },
        initSwiperImages() {
            let cardSliders = document.querySelectorAll(".card__slider");

            cardSliders.forEach((slider, index) => {
                if (slider.__swiper__) {
                    slider.__swiper__.destroy(true, true);
                }

                const swiper = new Swiper(slider, {
                    modules: [Pagination, EffectFade, Navigation],
                    observer: true,
                    observeParents: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    watchOverflow: true,
                    effect: "fade",
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    breakpoints: {
                        320: {},
                        768: {
                            touchRatio: 0,
                            navigation: {
                                prevEl: ".card-button_prev",
                                nextEl: ".card-button_next"
                            }
                        }
                    },
                    on: {
                        touchStart: (e) => {
                            if (slider.closest('.cards-main__slider').__swiper__) {
                                slider.closest('.cards-main__slider').__swiper__.allowTouchMove = false;
                            }
                        },
                        touchEnd: (e) => {
                            if (slider.closest('.cards-main__slider').__swiper__) {
                                slider.closest('.cards-main__slider').__swiper__.allowTouchMove = true;
                            }
                        }
                    }
                });

                slider.__swiper__ = swiper;
            });
        }
    },
    mounted() {
        this.initSwiperCards();
        this.$nextTick(() => {
            this.initSwiperImages();
        })
    }
}
</script>
